import { ReactElement, useEffect, useState } from 'react';
import AppErrorService from '../error/services/AppErrorService';
import useAppLog from './hooks/useAppLog';
type FAppLogProps = {
	children: ReactElement;
	e: Error & { component?: string; error?: Error };
};
const FAppLog = (props: FAppLogProps) => {
	const { e } = props;

	const appLog = useAppLog();

	const [errorSended, setErrorSended] = useState(false);

	useEffect(() => {
		if (appLog && e && errorSended === false) {
			let appErrorService = null;
			if (e.component) {
				appErrorService = new AppErrorService(e.error as Error, e.component);
			} else {
				appErrorService = new AppErrorService(e);
			}
			setErrorSended(true);
			appLog.error(e.name + ' ' + e.message + ' ' + document.location.href, {
				component: undefined,
				objDetails: appErrorService,
			});
		}
	}, [errorSended, appLog, e]);

	useEffect(() => {
		() => {
			setErrorSended(false);
		};
	}, []);

	return props.children;
};

export default FAppLog;
